<img *ngIf="imageSource" [src]="imageSource" class="injury-diagram" alt="Injury diagram" />
<div *ngIf="showMissingDiagramMessage" class="missing-diagram-message">
   Injury diagram could not be found.
</div>
